import Redirect from '@/components/Redirect'
import React, { Suspense, useEffect } from 'react'
import { connect } from 'react-redux'
import { Route, Routes } from 'react-router-dom'
import PersonalDetailsPage from '@/pages/PersonalDetailsPage'
import usePermissions from '@/hooks/usePermissions'
import Dashboard from '@/shared/Layout/Dashboard'
import AccountManagement from '../pages/Admin/AccountManagement'
import CompanyManagement from '../pages/Admin/CompanyManagement'
import ActivityList from '../pages/Admin/ActivityList'
import OperationLog from '../pages/Admin/OperationLog'
import PlanManagement from '../pages/Admin/PlanManagement'


const LandingPage = React.lazy(() => import('@/pages/LandingPage'))

const mapStateToProps = ({ auth }) => ({ token: auth.token })

const LandingPageSuspense = (
  <Suspense fallback={<div></div>}>
    <LandingPage />
  </Suspense>
)

const RenderRoute = ({
  children = [],
  suspense,
  suspenseFallback = <div></div>,
  element,
  permission,
  ...props
}) => {
  const hasPermission = usePermissions(permission)

  let routeElement = <Redirect />

  if (hasPermission) {
    routeElement = suspense ? <Suspense fallback={suspenseFallback}>{element}</Suspense> : element
  }

  return (
    <Route element={routeElement} {...props}>
      {children.map(childProps => RenderRoute(childProps))}
    </Route>
  )
}

const routes = [
  {
    key: '1',
    path: '/*',
    element: <Redirect />,
  },
  {
    key: '2',
    element: <Dashboard />,
    children: [
      { key: '2_1', path: '/account', element: <AccountManagement /> },
      { key: '2_2', path: '/company', element: <CompanyManagement /> },
      { key: '2_3', path: '/plan', element: <PlanManagement /> },
      { key: '2_4', path: '/activity', element: <ActivityList /> },
      { key: '2_5', path: '/auditlog', element: <OperationLog /> },
      // { key: '2_6', path: '/system', element: <SystemSettings/> },
      { key: '2_7', path: '/personal_details', element: <PersonalDetailsPage /> },
      
    ],
  },
  {
    key: '3',
    path: '/login',
    element: LandingPageSuspense,
  },
  {
    key: '4',
    path: '/login_verify',
    element: LandingPageSuspense,
  },
  {
    key: '5',
    path: '/forgot_password',
    element: LandingPageSuspense,
  },
  {
    key: '6',
    path: '/forgot_password_verify',
    element: LandingPageSuspense,
  },
  {
    key: '7',
    path: '/reset_password',
    element: LandingPageSuspense,
  },
]

const getPath = (paths, { path, permission, children = [] }) => {
  if (path) {
    paths.push({ path, permission })
  }

  children.forEach(child => {
    getPath(paths, child)
  })
}

const getPaths = () => {
  const paths = []

  routes.forEach(route => {
    getPath(paths, route)
  })

  return paths
}

const AppRoutes = ({ dispatch, token }) => {
  useEffect(() => {
    if (token) {
      dispatch({
        type: 'auth/getAccountData',
        successCallback: () => {
          dispatch({ type: 'account/getPermissions' })
        },
      })
    }
  }, [token, dispatch])

  return <Routes>{routes.map(route => RenderRoute(route))}</Routes>
}

export default connect(mapStateToProps)(AppRoutes)

export { routes, getPaths }
